module.exports = __webpack_public_path__ + "static/img/5.ef3c5b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/eng/5.png
// module id = e6i7
// module chunks = 0